// eslint-disable-next-line
import { RestClient } from '@sympalog/communication';
import { User } from '@sympalog/user';
import React from 'react';

import App from './App';

export interface AppContextData {
    app: App,
    user: User,
    restAppService: RestClient;
    restSymDialogService: RestClient;
}

interface AppProviderProps {
    ctx: AppContextData,
    children?: React.ReactNode,
}

export const AppContext = React.createContext( {} as AppContextData );

export function AppProvider( props: AppProviderProps ): JSX.Element {

    return(
        <AppContext.Provider value={props.ctx}>
            {props.children}
        </AppContext.Provider>
    );

}

export const AppConsumer = AppContext.Consumer;
